module.exports = __webpack_public_path__ + "img/service_4.a908c66b.png";